module.exports = __webpack_public_path__ + "static/media/branding_header.cab323b3.png";